import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse, ApiResponseData } from '../../../models/ApiResponseDto';
import { CreateNewPassword } from '../models/loginDto';
import { baseQueryWithReauth } from '../../../../middleware/dataSlice';

export const loginAPI = createApi({
    reducerPath: 'loginAPI',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        login: builder.mutation<{ accessToken: string }, { email: string; password: string, ip: string }>({
            query: (credentials) => ({
                url: '/api/Auth/adminlogin',
                method: 'POST',
                body: credentials,
            }),
            transformResponse: (response: { accessToken: string }) => response
        }),
        verifyCode: builder.mutation<ApiResponse, any>({
            query: (payload) => ({
                url: `/api/Auth/verifycode`,
                method: 'POST',
                body: payload
            }),
        }),
        resendCode: builder.mutation<ApiResponse, void>({
            query: (payload) => ({
                url: `/api/Auth/resendcode`,
                method: 'GET',
            }),
        }),
        forgotPassword: builder.mutation<ApiResponse, { email: string }>({
            query: ({ email }) => ({
                url: `/api/Auth/forgotPassword?email=${encodeURIComponent(email)}`,
                method: 'POST',
                //body: email
            }),
        }),
        getLoginUsers: builder.mutation<ApiResponseData, { mail: string | null }>({
            query: ({ mail }) => ({
                url: `/api/User/getLoginUsers`,
                method: 'POST',
            }),
        }),
        resetPassword: builder.mutation<ApiResponse, CreateNewPassword>({
            query: ({ password, confirmpassword }) => ({
                url: `/api/Auth/resetPassword`,
                method: 'POST',
                body: { password, confirmpassword },
            }),
        }),
        dynamicMenu: builder.mutation<any, void>({
            query: () => ({
                url: '/api/Authorization/dynamicMenu',
                method: 'GET',
            }),
        }),
        refreshtoken: builder.mutation<any, { refreshToken: string | null }>({
            query: (payload) => ({
                url: '/api/Auth/refreshtoken',
                method: 'POST',
                body: payload
            }),
        }),
    }),
});

export const { useLoginMutation, useVerifyCodeMutation, useResendCodeMutation, useForgotPasswordMutation,
    useGetLoginUsersMutation, useResetPasswordMutation, useDynamicMenuMutation, useRefreshtokenMutation } = loginAPI;
